<div class="bg-white pt-4 h-100 sidebar" [class.collapsed]="isCollapsed || isMobileView">
    <div class="d-flex justify-content-center mb-3" *ngIf="isCollapsed || isMobileView">
        <img src="../../assets/sicon.png" alt="sicon">
    </div>
    <div class="d-flex justify-content-between px-2">
        <img src="../../assets/logo.png" alt="logo" height="auto" *ngIf="!(isCollapsed || isMobileView)">
        <button class="btn bg-none w-100" (click)="toggleSidebar()">
            <mat-icon>menu</mat-icon>
        </button>
    </div>

    <div class="mt-4">

        <div *ngFor="let item of sidebarData">
            <button class="btn d-flex align-items-center navigation-btn gap-3 rounded-0 text-capitalize"
                routerLinkActive="active" matTooltip="{{item.description}}" routerLink="/{{item.route}}">
                <i class="{{item.icon}}"></i>
                <div *ngIf="showLabels" class="show-label">{{item.name | translate}}</div>
            </button>
        </div>

        <!-- <button class="btn d-flex align-items-center navigation-btn gap-3 rounded-0" routerLinkActive="active"
            routerLink="/portal/dashboard">
            <i class="pi pi-th-large"></i>
            <div *ngIf="showLabels" class="show-label">{{'dashboard' | translate}}</div>
        </button> -->

        <!-- <button class="btn d-flex align-items-center navigation-btn gap-3 rounded-0" routerLinkActive="active"
            routerLink="/portal/insert-claim">
            <i class="pi pi-file"></i>
            <div *ngIf="showLabels" class="show-label">{{'insertclaim' | translate}}</div>
        </button> -->

        <!-- <button class="btn d-flex align-items-center navigation-btn gap-3 rounded-0" routerLinkActive="active"
            routerLink="/portal/searchid">
            <i class="pi pi-search"></i>
            <div *ngIf="showLabels" class="show-label">{{'searchid' | translate}}</div>
        </button> -->

        <!-- <button class="btn d-flex align-items-center navigation-btn gap-3 rounded-0" routerLinkActive="active"
            routerLink="/portal/limits">
            <i class="pi pi-exclamation-triangle"></i>
            <div *ngIf="showLabels" class="show-label">{{'limits' | translate}}</div>
        </button> -->

        <!-- <button class="btn d-flex align-items-center navigation-btn gap-3 rounded-0" routerLinkActive="active"
            routerLink="/portal/tob">
            <i class="pi pi-list"></i>
            <div *ngIf="showLabels" class="show-label">{{'tob' | translate}}</div>
        </button> -->

        <!-- <button class="btn d-flex align-items-center navigation-btn gap-3 rounded-0" routerLinkActive="active"
            routerLink="/portal/contact">
            <i class="pi pi-envelope"></i>
            <div *ngIf="showLabels" class="show-label">{{'contact' | translate}}</div>
        </button> -->

        <!-- <button class="btn d-flex align-items-center navigation-btn gap-3 rounded-0" routerLinkActive="active"
            routerLink="/portal/preapproval">
            <i class="pi pi-check-circle"></i>
            <div *ngIf="showLabels" class="show-label">{{'preapproval' | translate}}</div>
        </button> -->

        <!-- <button class="btn d-flex align-items-center navigation-btn gap-3 rounded-0" routerLinkActive="active"
            routerLink="/portal/update-password">
            <i class="pi pi-key"></i>
            <div *ngIf="showLabels" class="show-label">{{'updatepassword' | translate}}</div>
        </button> -->

    </div>
</div>